<script>
  import HubModal from './HubModal.vue'
  import HubShare from './HubShare.vue'

  export default {
    props: ['piece', 'reveal'],

    components: {
      HubModal,
      HubShare
    },

    data () {
      return {
        modalOpen: this.$mq.desktop && this.piece.id == this.reveal,
        expandOpen: !this.$mq.desktop && this.piece.id == this.reveal
      }
    },

    methods: {
      open () {
        this.$mq.desktop ? this.modalOpen = true : this.expandOpen = true

        this.$nextTick(() => this.$emit('layout'))
      },

      close () {
        this.$mq.desktop ? this.modalOpen = false : this.expandOpen = false

        this.$nextTick(() => this.$emit('layout'))
      }
    },

    computed: {
      title () {
        return `“${this.piece.title}”`
      },

      playable () {
        return !! this.piece.video
      }
    }
  }
</script>

<template>
  <div class="item" :class="piece.type">
    <div class="figure" @click="open">
      <figure class="image is-square">
        <img :src="piece.image" />
        <div v-if="playable" class="play" />
      </figure>
    </div>
    <div class="caption">
      <div class="caption-props" @click="open">
        <div class="name" v-html="title"></div>
        <div class="meta">
          <div class="author">{{ piece.author }},</div>
          <div class="occupation">{{ piece.occupation }}</div>
        </div>
      </div>

      <div class="expanded" v-if="expandOpen">
        <div class="content">
          <div class="embed-container" v-if="piece.video" v-html="piece.video"></div>
          <div v-html="piece.description"></div>
          <p style="margin-top: 1rem;" v-if="piece.url && piece.visit"><a target="_blank" :href="piece.url">{{ piece.visit }}</a></p>
        </div>
        <a class="delete" @click="close"></a>

        <hub-share :piece="piece"></hub-share>
      </div>

    </div>

    <hub-modal :piece="piece" :open="modalOpen" :visit="piece.visit" @close="close"></hub-modal>
  </div>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  .item, .item a {
    color: white;
  }

  .figure, .caption-props {
    cursor: pointer;
  }

  .caption-props {
    display: flex;
    justify-content: space-between;
    padding: 1rem;
  }

  .name {
    font-family: "Separat";
    font-size: 1.125rem;
    text-transform: uppercase;
    max-width: 300px;
  }

  .meta {
    font-size: 0.75rem;
    text-align: center;
  }

  .expanded {
    padding: 1rem;
    position: relative;
  }

  .play {
    display: block;
    width: 122px;
    height: 122px;
    .moving & { background-image: url(../assets/play-red.svg); }
    .static & { background-image: url(../assets/play-blue.svg); }
    .audio & { background-image: url(../assets/play-pink.svg); }
    .interactive & { background-image: url(../assets/play-yellow.svg); }
    background-size: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -61px;
    margin-top: -61px;
  }

  .embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; margin-bottom: 1rem; }
  .embed-container /deep/ iframe { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }

  @include desktop {
    // thumb stuff
    .thumb .figure:after {
      content: "";
      display: block;
      width: 0;
      height: 0;

      position: absolute;
      top: calc(50% - 10px);
    }

    .thumb {
      display: flex;
    }

    .thumb .figure, .thumb .caption {
      width: 50%;
    }

    .thumb.right .figure {
      order: 2;
    }

    .thumb .caption {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 0 56px;
    }

    .thumb .caption-props {
      display: block;
    }

    .thumb .name {
      margin-bottom: 31px;
    }

    // arrows
    .thumb.left .figure:after {
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right:10px solid white;
      right: 50%;
    }

    .thumb.right .figure:after {
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid white;
      right: calc(50% + -10px);
    }

    // .large
    .large .caption {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }

  // colours
  @each $type, $colour in $types {

    .#{$type} .caption,
    .#{$type} .modal-content {
      background: $colour;
    }

    .#{$type}.right .figure:after {
      border-left-color: $colour;
    }

    .#{$type}.left .figure:after {
      border-right-color: $colour;
    }
  }

  .interactive.large .caption, .interactive.thumb {
    color: $blue;
  }
  .interactive.large .caption {
    background: $yellow;
  }
</style>



// WEBPACK FOOTER //
// partials/HubItem.vue